import { RootState } from '@/shared/store'

import { compartmentsAdapter } from './compartmentsAdapters'

export const compartmentsSelectors = compartmentsAdapter.getSelectors<RootState>(
  (state) => state.compartments,
)
